<mat-dialog-content style="height: 100%; overflow-y: hidden;">
  <div class="main-container">

    <mat-form-field style="width: 300px;" appearance="outline"> <!-- Outline pour que ça soit + visible -->
      <mat-label>{{ "Filtre" | translate }}</mat-label>
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [(ngModel)]="search" (keyup)="applyFilter()" placeholder="{{'Rechercher' | translate}}">
      <button mat-button *ngIf="search" matSuffix mat-icon-button aria-label="Clear" (click)="search=''; applyFilter()">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

    <div style="display: flex; flex: 1 1 auto; overflow-y: auto" class="medium-border-arma-color cmat-add-border">
      <table mat-table #tableProduct class="mat-elevation-z8" [dataSource]="dataSource">

        <!-- Code du produit -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.ProductCode">
          <th mat-header-cell *matHeaderCellDef #colHeaderProductCode>{{"Code Produit" | translate}}</th>
          <td mat-cell *matCellDef="let product">{{product.mProductCode}}</td>
        </ng-container>

        <!-- Libellé du produit -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Label">
          <th mat-header-cell *matHeaderCellDef #colHeaderLabel>{{"Label" | translate}}</th>
          <td mat-cell *matCellDef="let product">{{product.mLabel}}</td>
        </ng-container>

        <!-- Image du produit -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Image">
          <th mat-header-cell *matHeaderCellDef #colHeaderUnit>{{"Image" | translate}}</th>
          <td mat-cell *matCellDef="let product">
            <img *ngIf="product.mImage != null;"
              onerror='this.style.display = "none"'
              [src]="product.mImage == null ? '' : product.mImage"
              (click)="selectedImage = product.mImage"
              style="cursor: pointer;">
          </td>
        </ng-container>

        <!-- Qté à ajouter -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Qty">
          <th mat-header-cell *matHeaderCellDef #colHeaderProductQty>{{"Qty" | translate}}</th>
          <td mat-cell *matCellDef="let product">
            <input autocomplete="off" type="number" min="0" class="tab-input" [(ngModel)]="product.mQty" class="input-qty">
          </td>
        </ng-container>

        <!-- Unité du produit -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Unit">
          <th mat-header-cell *matHeaderCellDef #colHeaderUnit>{{"Unit" | translate}}</th>
          <td mat-cell *matCellDef="let product">
            <!-- LIST TYPE -->
            <mat-form-field class="mat-select-productUnit">
              <!-- {{product.mUnit1}} -->
              <mat-select (selectionChange)="onUnitChanged(product, $event.value)"
                          [value]="getSelectedUnit(product)">
                <mat-option *ngFor="let unit of getUnitList(product)" value="{{unit}}">
                  {{unit}}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </td>
        </ng-container>

        <!-- Poids unitaire -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Weight">
          <th mat-header-cell *matHeaderCellDef #colHeaderWeight>{{"Weight" | translate}}</th>
          <td mat-cell *matCellDef="let product">
            {{ getProductWeight(product) }}
          </td>
        </ng-container>

        <!-- Button to add a product -->
        <ng-container [matColumnDef]="HTML_PRODUCTINPUT_COL.Add">
          <th mat-header-cell *matHeaderCellDef #colHeaderProductAdd></th>
          <td mat-cell *matCellDef="let product">
            <button mat-mini-fab color="primary" class="btn-add" (click)="onProdBtnClick(product)">+</button>
          </td>
        </ng-container>

        <tr mat-header-row class="armaor-background-color tr-header" *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="ana-line" (dblclick)="onTableLineDblClick(row)"></tr>
      </table>
    </div>

    <div mat-dialog-actions style="margin-bottom: 0px;">
      <button mat-raised-button (click)="onDialogBtnClick('OK')">{{'OK' | translate}}</button>
      <button mat-raised-button color="warn" (click)="onDialogBtnClick('CANCEL')">{{'Annuler' | translate}}</button>
    </div>

  </div>
</mat-dialog-content>

<!-- Sert à afficher une image en grand quand on clique sur l'image -->
<div class="image-focus"
    (click)="selectedImage=''"
    [attr.data-visibility]="selectedImage != '' ? 'visible' : 'hidden'">
    <img [src]="selectedImage"/>
</div>
